import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, CircularProgress, Grid, Typography } from '@mui/material'

import { useGetScreenshotCommentQuery } from '../../api/core'
import { useCurrentUserLanguage } from '../../features/account/hooks/useCurrentUserLanguage'
import { useContentTranslation } from '../../hooks/translationHooks'
import languageService from '../../services/LanguageService'
import { TranslationToggle } from '../TranslationToggle/TranslationToggle'

interface AnalystCommentProps {
  commentId: string
}

const AnalystComment: React.FC<AnalystCommentProps> = ({ commentId }) => {
  const { t } = useTranslation()
  const userLanguage = useCurrentUserLanguage()
  const { data, isFetching } = useGetScreenshotCommentQuery(commentId)
  const { isTranslating, translatedContent, translationError, handleTranslateClick, resetTranslation, displayContent } = useContentTranslation()

  const commentContent = data?.screenshotComment.content.comment[userLanguage] || data?.screenshotComment.content.comment[languageService.defaultLanguage] || ''
  const showTranslationToggle = commentContent && userLanguage !== 'en'

  useEffect(() => {
    resetTranslation()
  }, [commentId, resetTranslation])

  return (
    <Grid container alignItems="center" justifyContent="space-between" className="analystComment modalFooter">
      <Grid item md={8}>
        <Grid container direction="row" alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h2" color="primary">
              {t('reviews:label_analyst_comment')}
            </Typography>
          </Grid>
          {showTranslationToggle && !isFetching && (
            <Grid item>
              <TranslationToggle
                isTranslating={isTranslating}
                hasTranslation={!!translatedContent}
                error={translationError}
                onToggle={() => handleTranslateClick(commentContent, userLanguage)}
              />
            </Grid>
          )}
        </Grid>
        {isFetching ? <CircularProgress size={16} /> : <Typography dangerouslySetInnerHTML={{ __html: displayContent(commentContent) }} />}
      </Grid>
      {data?.analyst && (
        <Grid item md={4} textAlign="right">
          <Box className="inline">
            <Typography variant="h2" color="primary">
              {data.analyst.name}
            </Typography>
            <Typography variant="subtitle2">{data.analyst.title}</Typography>
          </Box>
          <img src={data.analyst.picture} alt={data.analyst.name} className="analystImage" />
        </Grid>
      )}
    </Grid>
  )
}

export default AnalystComment
